const entryCountFormatter = new Intl.NumberFormat('en-US', {
  maximumFractionDigits: 0,
});

export const formatEntryCount = (value: number | string) => {
  const count = Number(value);
  return entryCountFormatter.format(Number.isFinite(count) ? count : 0);
};
